import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { HistoryRow } from "../historyViewConfig";
import { getActivityDescriptionParts } from "../../utils/getActivityDescription";
import styles from "./Cell.module.scss";

export const ActivityCell = memo(
    ({ row }: CellContext<ViewTableFeatures, HistoryRow, string>) => {
        const { prefix, counter, suffix } = getActivityDescriptionParts(
            row.original,
        );

        return (
            <ViewTableCell className={styles.activityCell}>
                {prefix && <span>{prefix}</span>}
                {counter && <span className={styles.counter}> {counter}</span>}
                {suffix && <span> {suffix}</span>}
            </ViewTableCell>
        );
    },
);

ActivityCell.displayName = "ActivityCell";
